import { render, staticRenderFns } from "./FormCISAccount.vue?vue&type=template&id=6ac74e95&scoped=true"
import script from "./FormCISAccount.vue?vue&type=script&lang=js"
export * from "./FormCISAccount.vue?vue&type=script&lang=js"
import style0 from "./FormCISAccount.vue?vue&type=style&index=0&id=6ac74e95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac74e95",
  null
  
)

export default component.exports